module.exports = __webpack_public_path__ + "img/logo-9.179cdd68.png";